export default __webpack_public_path__ + "static/media/CardRussinsauna.7e95cf60.jpg";